/* eslint-disable no-underscore-dangle */

/**
 * Translations is a new entry point on webpack, so it can be in included as critical path on http-webserver;
 * window.__TBD__.TRANSLATIONS is included in client.tsx afterwards
 */
// eslint-disable-next-line import/no-relative-packages
import TRANSLATIONS from "./generated/translations/en_GB.json";

window.__TBD__ = {
  ...window.__TBD__,
  TRANSLATIONS,
};
